/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { LossFactorsService } from './services/LossFactorsService';
import { MonitoringService } from './services/MonitoringService';
import { TestService } from './services/TestService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class LossFactorManagerClient {

    public readonly lossFactors: LossFactorsService;
    public readonly monitoring: MonitoringService;
    public readonly test: TestService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://localhost:8100',
            VERSION: config?.VERSION ?? '1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.lossFactors = new LossFactorsService(this.request);
        this.monitoring = new MonitoringService(this.request);
        this.test = new TestService(this.request);
    }
}

